import styled from "styled-components";

import { Placeholder } from "components/Placeholder";
import { CardContainer } from "features/Strategy/v2/Detail/StrategyDetails.styles";
import { Title } from "style/components/Title.styles";

const DescriptionPlaceholderContainer = styled.div`
  .placeholder-glow {
    margin-bottom: 0;
    flex: 1;
  }
`;

const DescriptionPlaceholder = () => {
  return (
    <DescriptionPlaceholderContainer>
      <CardContainer className="description-wrapper">
        <Title className="title">Description</Title>
        {Array.from({ length: 5 }, (_, index) => (
          <Placeholder className="custom-placeholder" as="p" key={index} />
        ))}
      </CardContainer>
    </DescriptionPlaceholderContainer>
  );
};

export default DescriptionPlaceholder;
